<template>
  <div>
    <a-range-picker
      :ranges="{
        一周: [moment().subtract(7, 'days'), moment()],
        一个月: [moment().subtract(1, 'months'), moment()],
        半年: [moment().subtract(6, 'months'), moment()],
        一年: [moment().subtract(1, 'years'), moment()],
      }"
      :default-value="[startValue, endValue]"
      :format="dateFormat"
      @change="onChange"
      @openChange="handleEndOpenChange"
    />
    <!-- <a-row type="flex"
      style="width:100%"
      :gutter="10"
      justify="end">
      <a-col :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
        :xl="12">
        <a-date-picker style="width:100%"
          v-model="startValue"
          :disabled-date="disabledStartDate"
          :format="dateFormat"
          placeholder="开始时间"
          @change="onChange"
          :showToday="false"
          @openChange="handleStartOpenChange" />
      </a-col>
      <a-col :xs="24"
        :sm="24"
        :md="12"
        :lg="12"
        :xl="12">
        <a-date-picker @change="handleDateChange"
          v-model="endValue"
          style="width:100%"
          :disabled-date="disabledEndDate"
          :format="dateFormat"
          placeholder="结束时间"
          :open="endOpen"
          :showToday="false"
          @openChange="handleEndOpenChange" />
      </a-col>
    </a-row> -->
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    value: Object,
    dataindex: String,
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val) {
        console.log(val)
        // Object.assign(this.createTime, val);
        this.createTime = val
        console.log(this.createTime)
        let a = `${this.dataindex}_begin`
        if (val[a]) {
          this.startValue = this.moment(val[a])
        } else {
          this.startValue = null
          this.createTime[a] = null
        }
        let b = `${this.dataindex}_end`
        if (val[b]) {
          this.endValue = this.moment(val[b])
        } else {
          this.endValue = null
          this.createTime[b] = null
        }
      },
    },
  },
  data() {
    return {
      dateFormat: 'YYYY-MM-DD',
      endOpen: false,
      startTime: '',
      endTime: '',
      startValue: null,
      endValue: null,
      createTime: {
        createTime_begin: '', //开始时间
        createTime_end: '', //结束时间
      },
    }
  },
  created() {},
  methods: {
    moment,
    // 开始时间
    onChange(mon, dateStr) {
      console.log(mon, dateStr)
      let a = `${this.dataindex}_begin`
      this.createTime[a] = dateStr[0]
      let b = `${this.dataindex}_end`
      this.createTime[b] = dateStr[1]
      //   // this.$emit('input', this.createTime)
      //   this.startTime = dateStr
    },
    // 结束时间
    handleDateChange(mon, dateStr) {
      let b = `${this.dataindex}_end`
      this.createTime[b] = dateStr
      // this.$emit('input', this.createTime);
      this.endTime = dateStr
    },
    //开始时间限制
    disabledStartDate(startValue) {
      const endValue = this.endValue
      if (!startValue || !endValue) {
        return startValue > this.moment().subtract('days', 0)
      }
      if (startValue >= this.moment().subtract('days', 0).valueOf()) {
        return startValue.valueOf() >= this.moment().subtract('days', 0)
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    //结束时间限制
    disabledEndDate(endValue) {
      const startValue = this.startValue
      if (!endValue || !startValue) {
        return endValue.valueOf() > this.moment().subtract('days', 0)
      }
      if (endValue >= this.moment().subtract('days', 0).valueOf()) {
        return endValue.valueOf() >= this.moment().subtract('days', 0)
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    //开始时间选择完成
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    //结束时间选择完成
    handleEndOpenChange(open) {
      this.endOpen = open
      const that = this
      setTimeout(() => {
        that.$emit('input', that.createTime)
      }, 500)
    },
  },
}
</script>
<style lang="less" scoped></style>
